import { render, staticRenderFns } from "./AdSelfList.vue?vue&type=template&id=3637a466&scoped=true&"
import script from "./AdSelfList.vue?vue&type=script&lang=js&"
export * from "./AdSelfList.vue?vue&type=script&lang=js&"
import style0 from "./AdSelfList.vue?vue&type=style&index=0&id=3637a466&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3637a466",
  null
  
)

export default component.exports